import api from '@/lib/api';
import type { PaginatedResponse } from '@pms/shared';

// ─── Interfaces ──────────────────────────────────────────────────────────────

export interface NightAuditSummary {
  // Backend actual fields
  totalRooms?: number | undefined;
  occupied?: number | undefined;
  occupancyRate?: number | undefined;
  revenue?: string | number | undefined;
  arrivals?: number | undefined;
  departures?: number | undefined;
  unreconciledCount?: number | undefined;
  unreconciledTotal?: string | number | undefined;
  exceptions?: string[] | undefined;
  // Legacy fields (kept for backward compatibility)
  totalRoomRevenue?: string | undefined;
  totalTax?: string | undefined;
  totalPayments?: string | undefined;
  occupancyPercentage?: number | undefined;
  adr?: string | undefined;
  revPar?: string | undefined;
  arrivalsCount?: number | undefined;
  departuresCount?: number | undefined;
  noShowsCount?: number | undefined;
  inHouseCount?: number | undefined;
}

export interface NightAuditLog {
  id: string;
  propertyId: string;
  businessDate: string;
  status: 'pending' | 'in_progress' | 'completed' | 'failed';
  startedAt: string | null;
  completedAt: string | null;
  performedBy: string;
  summary: NightAuditSummary;
  createdAt: string;
}

export interface RunNightAuditPayload {
  propertyId: string;
  force?: boolean | undefined;
}

export interface NightAuditHistoryQuery {
  propertyId?: string | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

// ─── API functions ───────────────────────────────────────────────────────────

export async function runNightAudit(payload: RunNightAuditPayload): Promise<NightAuditLog> {
  const { data } = await api.post('/night-audit/run', payload);
  return data;
}

export async function fetchNightAuditHistory(query: NightAuditHistoryQuery): Promise<PaginatedResponse<NightAuditLog>> {
  const { data } = await api.get<PaginatedResponse<NightAuditLog>>('/night-audit/history', { params: query });
  return data;
}

export async function fetchNightAuditDetail(id: string): Promise<NightAuditLog> {
  const { data } = await api.get(`/night-audit/${id}`);
  return data;
}
